import { colors, solidFill } from '../constants/colors';

export const rows = {
  header: 0,
  tableHeader: 2,
  tableData: (index: number) => 3 + index,
};

export const columnIndices = {
  mainHeader: 0,
  required: 0,
  columnName: 1,
  description: 2,
  sampleData: 3,
  additionalInstructions: 5,
};

export const styles = {
  header: {
    font: {
      size: 16,
      bold: true,
    },
  },
  requiredMark: {
    font: {
      color: colors.red,
      size: 16,
      bold: true,
    },
    alignment: {
      horizontal: 'right',
    },
  },
  requiredMarkDescription: {
    font: {
      color: colors.red,
      size: 16,
      bold: true,
    },
  },
  columnNameHeader: {
    fill: solidFill(colors.darkGreen),
    font: {
      color: colors.white,
      bold: true,
    },
  },
  columnHeader: {
    fill: solidFill(colors.darkGray),
    font: {
      color: colors.white,
      bold: true,
    },
  },
  columnNameBody: {
    fill: solidFill(colors.lightGreen),
  },
  columnBody: {
    fill: solidFill(colors.lightGray),
  },
} as const;

export const columnStyles = [
  { width: 5, font: { size: 12 } }, // column A: 'Required'
  { width: 25, font: { size: 12 } }, // column B: 'Column name'
  { width: 50, font: { size: 12 } }, // column C: 'Description'
  { width: 15, font: { size: 12 } }, // column D: 'Sample data'
  {}, // column E: 'empty/spacer'
  { width: 15, font: { size: 12 } }, // column F: 'Additional instructions'
] as const;

export const initialCellStyles = [
  // header
  {
    address: {
      column: columnIndices.mainHeader,
      row: rows.header,
    },
    style: styles.header,
  },
  {
    address: {
      column: columnIndices.additionalInstructions,
      row: rows.header,
    },
    style: styles.header,
  },
  // table
  {
    address: {
      row: rows.tableHeader,
      column: columnIndices.columnName,
    },
    style: styles.columnNameHeader,
  },
  {
    address: {
      row: rows.tableHeader,
      column: columnIndices.description,
    },
    style: styles.columnHeader,
  },
  {
    address: {
      row: rows.tableHeader,
      column: columnIndices.sampleData,
    },
    style: styles.columnHeader,
  },
] as const;
